import gql from 'graphql-tag';

export default gql`
  mutation deleteApiKey($id: String!) {
    deleteApiKey(id: $id) {
      id
    }
  }
`;
